import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
import "@fancyapps/ui/dist/fancybox.css";

Fancybox.bind("[data-fancybox]", {
  dragToClose: false
})